import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  isEmpty, noop, map, capitalize,
} from 'lodash';
import withReactContent from 'sweetalert2-react-content';
import Swal from 'sweetalert2';
import {
  Button,
  Select,
  SearchSelect,
} from '../../components/base/index';

const MySwal = withReactContent(Swal);

export default class ResetPass extends Component {
  constructor(props) {
    super(props);
    this._onChangeFilter = this._onChangeFilter.bind(this);
    this._onSearchContent = this._onSearchContent.bind(this);
    this.onReset = this.onReset.bind(this);
    this._getUsernameOptions = this._getUsernameOptions.bind(this);
    this._getUserGroups = this._getUserGroups.bind(this);
    this._getSchoolUnitsOptions = this._getSchoolUnitsOptions.bind(this);

    const { user } = this.props;
    const { school_unit } = user;
    this.state = {
      page: 1,
      filters: {},
      form: {
        value: {
          listuser: [],
        },
        error: {},
      },
      param: {},
    };
  }

  componentDidMount() {
    this._onSearchContent();
    this._getUsernameOptions();
    this._getUserGroups();
    this._getSchoolUnitsOptions();
  }

  // componentDidUpdate(prevProps) {
  //   // const { user } = this.props;
  //   // const { workingUnit } = user;
  //   // const { user: prevUser } = prevProps;
  //   // const { workingUnit: prevWorkingUnit } = prevUser;

  //   // if (!isEqual(workingUnit, prevWorkingUnit)) {
  //   //   this.handleGetData();
  //   // }
  //   if (!isEqual(prevProps, this.props)) {
  //     this._onSearchContent({ page: 1 });
  //   }
  // }

  async _getSchoolUnitsOptions(filters = {}) {
    const { getSchoolUnitsOptions } = this.props;
    const { form } = this.state;
    const { units_id } = form.value;
    const res = await getSchoolUnitsOptions(filters);
    const selectedUnits = res.find(item => item.value == units_id);

    // console.log(units_id)
    this.setState(prevState => ({
      ...prevState,
      form: {
        ...prevState.form,
        value: {
          ...prevState.form.value,
          levels_units: selectedUnits ? selectedUnits.attributes.levels_id : '',
        },
      },
      param: {
        ...prevState.param,
        units: res,
      },
    }));
  }

  _onChangeFilter(e) {
    const { target } = e;
    const { value, name } = target;
    if (name === 'user_groups_id') {
      this.setState(prevState => ({
        filters: {
          ...prevState.filters,
          username: '',
        },
      }));
    }
    this.setState(prevState => ({
      ...prevState,
      filters: {
        ...prevState.filters,
        [name]: value,
      },
    }),
    () => {
      if (name === 'user_groups_id') {
        this._getUsernameOptions();
      }
      if (name === 'units_id') {
        const param = this.state.param.units;
        const levels_units = param.find(i => i.value == value.value) ? param.find(i => i.value == value.value).attributes.levels_id : '';
        const units_id = param.find(i => i.value == value.value) ? param.find(i => i.value == value.value).value : '';

        console.log(levels_units);
        this.setState(prevState => ({
          ...prevState,
          form: {
            ...prevState.form,
            value: {
              ...prevState.form.value,
              units_id: value,
            },
            error: {},
          },
          filters: {
            ...prevState.filters,
            username: '',
          },
        }));
        this._getUsernameOptions({ units_id: value });
      }
      this._onSearchContent();
    });
  }

  async _onSearchContent(params = {}) {
    const { filters, param, savedUnits } = this.state;
    const savedFilters = JSON.parse(window.localStorage.getItem('param')) || '';
    const prm_usergroups = savedFilters.userGroups;
    const userStudents = prm_usergroups ? prm_usergroups.find(e => e.label == 'student') : '';


    if (filters.user_groups_id === '') {
      delete filters.user_groups_id;
    }
    if (filters.username === '' || !isEmpty(filters.username) && filters.username.value === '') {
      delete filters.username;
    }


    console.log(filters);
    console.log(savedUnits);

    this.setState(async () => {
      try {
        const {
          handleListResetPassword,
          user,
        } = this.props;
        const { form, filters } = this.state;
        const { value } = form;
        const { units_id } = filters;
        const { school_unit, organizations_id, user_group } = user;
        const units = user_group.name == 'pusat' ? units_id.value : school_unit.id;
        console.log(units);
        let result = {};

        if (!(savedUnits && savedUnits.units == units)) {
          delete filters.username;
          this.setState(prevState => ({
            ...prevState,
            savedUnits: {
              units,
            },
          }));
        }
        result = await handleListResetPassword({
          organizations_id,
          units_id: units,
          filters: { user_groups_id: userStudents.value, username: filters.username },
        });

        this.setState(prevState => ({
          ...prevState,
          form: {
            ...prevState.form,
            value: {
              ...prevState.form.value,
              listuser: result,
            },
          },
        }));
      } catch (err) {
        // if (this.isMount) {
        this.setState(prevState => ({
          ...prevState,
          form: {
            ...prevState.form,
            value: {
              ...prevState.form.value,
              listuser: [],
            },
          },
        }));
      }
      // }
    });
  }

  async onReset(data) {
    const { handleResetPassword } = this.props;
    // MySwal.fire({
    //   title: <p>Rincian Pembayaran</p>,
    //   // showCancelButton: false,
    //   // showConfirmButton: false,
    //   title: "Reset Kata Sandi",
    //   text: "Username : " + data.username + "<br> Nama",
    //   icon: 'warning',
    //   showCancelButton: true,
    //   showConfirmButton: true,
    // });
    const res = await handleResetPassword(data);
  }

  async _getUsernameOptions() {
    const { getUsernameOptions, user } = this.props;
    const { school_unit, user_group } = user;
    const { filters, param } = this.state;
    const { units_id } = filters;
    const savedFilters = JSON.parse(window.localStorage.getItem('param')) || '';
    const prm_usergroups = savedFilters.userGroups;
    const userStudents = prm_usergroups ? prm_usergroups.find(e => e.label == 'student') : '';
    const units_value = units_id ? units_id.value : '';
    const units = user_group.name == 'pusat' ? units_value : school_unit.id;
    console.log(filters);
    if (filters.user_groups_id === '') {
      delete filters.user_groups_id;
    }
    const res = await getUsernameOptions({
      units_id: units,
      filters: { user_groups_id: userStudents.value },
    });
    this.setState(prevState => ({
      ...prevState,
      param: {
        ...prevState.param,
        user: res,
      },
    }));
  }

  async _getUserGroups() {
    const { getUserGroups, user } = this.props;
    const { school_unit, organizations_id } = user;
    const { filters } = this.state;

    filters.organizations_id = organizations_id;

    const res = await getUserGroups(filters);
    console.log(res);
    this.setState(prevState => ({
      ...prevState,
      param: {
        ...prevState.param,
        userGroups: res,
      },
    }));
    window.localStorage.setItem('param', JSON.stringify(this.state.param));
  }

  _renderButtons(data) {
    const { user } = this.props;

    return (
      <td>
        <div className="table__actions">
          <Button onClick={() => this.onReset(data)} title="Reset" />
        </div>
      </td>
    );
  }

  render() {
    const {
      form,
      filters,
      param,
    } = this.state;
    const { listuser } = form.value;
    const { user } = this.props;
    const { user_group } = user;
    const prm_usergroups = param.userGroups;
    const prm_user = [
      { value: 1, label: 'User Siswa' },
      { value: 2, label: 'User Guru' },
    ];

    const userStudents = prm_usergroups ? prm_usergroups.find(e => e.label == 'student') : '';
    // window.localStorage.setItem('param', JSON.stringify(this.state.param));

    // console.log(JSON.parse(window.localStorage.getItem('param')))

    // this.setState((prevState) => ({
    //   ...prevState,
    //   form: {
    //     ...prevState.form,
    //     value: {
    //       ...prevState.form.value,
    //       userStudents: userStudents,
    //     }
    //   }
    // }))
    return (
      <div className="manage-registration">
        <h1>Atur Ulang Kata Sandi</h1>
        <hr />
        <div className="absensi-rekap__custom-form">
          {(user_group.name === 'pusat')
            ? (
              <div className="absensi-rekap__custom-form-row">
                <div className="absensi-rekap__custom-form-row__field">
                  <SearchSelect
                    noMargin
                    async={false}
                    name="units_id"
                    list={param.units}
                    inputArray
                    onClick={this._onChangeFilter}
                    placeholder="Pilih Unit"
                    value={form.value.units_id}
                    rightIcon="icon-search"
                    label="Pilih Unit"
                  />
                </div>
              </div>
            )
            : ''}
          <div className="absensi-rekap__custom-form-row">
            <div className="absensi-rekap__custom-form-row__field">
              <Select
                name="user_groups_id"
                label="Pilih Jenis User"
                onChange={this._onChangeFilter}
                data={param.userGroups}
                placeholder="Pilihan"
                value={userStudents.value}
                disabled
              />
            </div>
            <div className="absensi-rekap__custom-form-column__field">
              <SearchSelect
                noMargin
                async={false}
                name="username"
                list={param.user}
                inputArray
                onClick={this._onChangeFilter}
                placeholder="Pilihan"
                value={filters.username}
                rightIcon="icon-search"
                label="Pilih User"
              />
            </div>
          </div>
        </div>
        <div className="manage-registration">
          <div className="fund-request__content">
            <table className="table">
              <thead>
                <tr>
                  <th>No</th>
                  <th>Username</th>
                  <th>Nama</th>
                  <th>Opsi</th>
                </tr>
              </thead>
              <tbody>
                {map(listuser, (list, idx) => (
                  <tr key={`budget_row_${idx}`}>
                    <td style={{ textAlign: 'center' }} key={`table_$${idx}`}>
                      {idx + 1}
                    </td>
                    <td key={`table_${idx}`} style={{ textAlign: 'center' }}>
                      {list.username}
                    </td>
                    <td key={`table_${idx}`} style={{ textTransform: 'capitalize' }}>
                      {capitalize(list.name)}
                    </td>
                    {this._renderButtons(list)}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  }
}
ResetPass.propTypes = {
  handleGetStudent: PropTypes.func,
  handleDeleteStudent: PropTypes.func,
  history: PropTypes.object.isRequired,
};
ResetPass.defaultProps = {
  handleGetStudent: noop,
  handleDeleteStudent: noop,
};
